import type {
  XmlInjection,
  XmlInjectionTarget,
  BookmarkInjection,
} from "../global";
import { findParagraph, findSegmentRange } from "./Edit";

export default async function inject(
  context: Word.RequestContext,
  injection: XmlInjection
) {
  for (const bookmark of injection.bookmarks ?? []) {
    await injectBookmark(context, bookmark);
  }
  const p = await injectParagraph(context, injection.target, injection.oxml);
  p.select("Select");
  await context.sync();
}

export async function injectParagraph(
  context: Word.RequestContext,
  target: XmlInjectionTarget,
  oxml: string
): Promise<Word.Paragraph> {
  let p: Word.Paragraph | undefined;
  if (target.method === "EndOfDocument") {
    p = context.document.body.insertOoxml(oxml, "End").paragraphs.items[0];
  } else if (target.method === "BeforeParagraph" && target.paragraph) {
    const pBefore = await findParagraph(context, target.paragraph);
    p = pBefore.range.insertParagraph("", "Before");
    p.insertOoxml(oxml, "Replace");
  } else if (
    target.method == "OnSegment" &&
    target.paragraph &&
    target.segment
  ) {
    const _p = await findParagraph(context, target.paragraph);
    p = _p.range;
    const s = await findSegmentRange(context, p, target.segment);
    s.insertOoxml(oxml, "Replace");
  }

  if (p === undefined) {
    throw new Error("Paragraph not found");
  }

  await context.sync();
  return p;
}

export async function injectBookmark(
  context: Word.RequestContext,
  bookmark: BookmarkInjection
) {
  const p = await findParagraph(context, bookmark.paragraph);
  const r: Word.Range = p.range.getRange("Start");
  r.insertBookmark(bookmark.bookmarkName);
  await context.sync();
}
